import FileLinkWrapper from './FileLinkWrapper';

export default FileLinkWrapper;
